"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.toOperationExtraRaw = exports.fromOperationExtraRaw = void 0;
var invariant_1 = __importDefault(require("invariant"));
var bignumber_js_1 = require("bignumber.js");
var account_1 = require("../../account");
var currencies_1 = require("../../currencies");
function formatOperationSpecifics(op, unit) {
    var _a = op.extra, validators = _a.validators, bondedAmount = _a.bondedAmount, unbondedAmount = _a.unbondedAmount, withdrawUnbondedAmount = _a.withdrawUnbondedAmount, validatorStash = _a.validatorStash, amount = _a.amount;
    var str = (validators || []).map(function (v) { return "\n    ".concat(v); }).join("");
    var formatConfig = {
        disableRounding: true,
        alwaysShowSign: false,
        showCode: true
    };
    str +=
        bondedAmount && !bondedAmount.isNaN()
            ? "\n    bondedAmount: ".concat(unit
                ? (0, currencies_1.formatCurrencyUnit)(unit, bondedAmount, formatConfig)
                : bondedAmount)
            : unbondedAmount && !unbondedAmount.isNaN()
                ? "\n    unbondedAmount: ".concat(unit
                    ? (0, currencies_1.formatCurrencyUnit)(unit, unbondedAmount, formatConfig)
                    : unbondedAmount)
                : withdrawUnbondedAmount && !withdrawUnbondedAmount.isNaN()
                    ? "\n    withdrawUnbondedAmount: ".concat(unit
                        ? (0, currencies_1.formatCurrencyUnit)(unit, withdrawUnbondedAmount, formatConfig)
                        : withdrawUnbondedAmount)
                    : "";
    str += validatorStash ? "\n    validatorStash: ".concat(validatorStash) : "";
    str += amount
        ? "\n    amount: ".concat(unit ? (0, currencies_1.formatCurrencyUnit)(unit, amount, formatConfig) : amount)
        : "";
    return str;
}
function formatAccountSpecifics(account) {
    var _a;
    var polkadotResources = account.polkadotResources;
    (0, invariant_1["default"])(polkadotResources, "polkadot account expected");
    var unit = (0, account_1.getAccountUnit)(account);
    var formatConfig = {
        disableRounding: true,
        alwaysShowSign: false,
        showCode: true
    };
    var str = " ";
    str +=
        (0, currencies_1.formatCurrencyUnit)(unit, account.spendableBalance, formatConfig) +
            " spendable. ";
    if (polkadotResources.lockedBalance.gt(0)) {
        str +=
            (0, currencies_1.formatCurrencyUnit)(unit, polkadotResources.lockedBalance, formatConfig) + " locked. ";
    }
    if (polkadotResources.unlockedBalance.gt(0)) {
        str +=
            (0, currencies_1.formatCurrencyUnit)(unit, polkadotResources.unlockedBalance, formatConfig) + " unlocked. ";
    }
    if (polkadotResources.stash) {
        str += "\nstash : " + polkadotResources.stash;
    }
    if (polkadotResources.controller) {
        str +=
            "\ncontroller : " + polkadotResources.controller;
    }
    if ((_a = polkadotResources.nominations) === null || _a === void 0 ? void 0 : _a.length) {
        str += "\nNominations\n";
        str += polkadotResources.nominations
            .map(function (v) { return "  to ".concat(v.address); })
            .join("\n");
    }
    return str;
}
function fromOperationExtraRaw(extra) {
    if (extra && extra.transferAmount) {
        extra = __assign(__assign({}, extra), { transferAmount: extra.transferAmount.toString() });
    }
    if (extra && extra.bondedAmount) {
        return __assign(__assign({}, extra), { bondedAmount: new bignumber_js_1.BigNumber(extra.bondedAmount) });
    }
    if (extra && extra.unbondedAmount) {
        return __assign(__assign({}, extra), { unbondedAmount: new bignumber_js_1.BigNumber(extra.unbondedAmount) });
    }
    if (extra && extra.withdrawUnbondedAmount) {
        return __assign(__assign({}, extra), { withdrawUnbondedAmount: new bignumber_js_1.BigNumber(extra.withdrawUnbondedAmount) });
    }
    // for subscan reward & slash
    if (extra && extra.amount) {
        return __assign(__assign({}, extra), { amount: new bignumber_js_1.BigNumber(extra.amount) });
    }
    return extra;
}
exports.fromOperationExtraRaw = fromOperationExtraRaw;
function toOperationExtraRaw(extra) {
    if (extra && extra.transferAmount) {
        extra = __assign(__assign({}, extra), { transferAmount: extra.transferAmount.toString() });
    }
    if (extra && extra.bondedAmount) {
        return __assign(__assign({}, extra), { bondedAmount: extra.bondedAmount.toString() });
    }
    if (extra && extra.unbondedAmount) {
        return __assign(__assign({}, extra), { unbondedAmount: extra.unbondedAmount.toString() });
    }
    if (extra && extra.withdrawUnbondedAmount) {
        return __assign(__assign({}, extra), { withdrawUnbondedAmount: extra.withdrawUnbondedAmount.toString() });
    }
    // for subscan reward & slash
    if (extra && extra.amount) {
        return __assign(__assign({}, extra), { amount: extra.amount.toString() });
    }
    return extra;
}
exports.toOperationExtraRaw = toOperationExtraRaw;
exports["default"] = {
    formatAccountSpecifics: formatAccountSpecifics,
    formatOperationSpecifics: formatOperationSpecifics,
    fromOperationExtraRaw: fromOperationExtraRaw,
    toOperationExtraRaw: toOperationExtraRaw
};
//# sourceMappingURL=account.js.map